module.exports = __webpack_public_path__ + "static/top-trainer-72c7285dd2c828ab3124dc577c47e272.png";